import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { formatDate, IconButton, SubmitButton, TextBox } from "../../Components/InputElements";
import Select from 'react-select';
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData, decodeUrl, encodeData } from "../../Constants/constants";
import * as XLSX from 'xlsx';

class OffboardingLogs extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      location_title: "",
      location_description: "",
      departmentOptions: "",
      locationOptions: "",
      department: "",
      location: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      location_id: '',
      department_id: '',
      designation_id: '',
      from_date: "",
      to_date: "",
      selectOption: "",
      targetDiv1Height: "auto",
      targetDiv2Height: "auto",
      loadingSearch: false,
      loadingExcel: false,
      encodedData: '',
      decodedDataId: '',
      decodedData: [],
      excelEmployeeStatus: "All",
      openSheetsOptions: false,
      allSheetChecked: false,
      basicDetails: false,
      educationDetails: false,
      salaryDetails: false,
      documentDetails: false,
      bankDetails: false,
      statutoryDetails: false,
      experienceDetails: false,
      familyDetails: false,
      // documentDetails: false,
      department_title:'',
      employee_status:' ',
      location_options: [],
      department_options: [],
      designation_options: [],
      grade_options: [],
      state_options: [],
      formData: {},
      viewEmployeeOffboardingLogs: false,
      

    };
    this.departmentDivRef = React.createRef(); 
    this.departmentSelectRef = React.createRef(); 

    this.locationDivRef = React.createRef();
    this.locationSelectRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.getDepartmentFilterList();
      this.getLocationFilterList();
      this.adjustHeights(); 
      this.GetEmploymentMasterList();
    });
  }
componentDidUpdate(prevProps, prevState) {
    this.adjustHeights(); 
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedDataId = decodeUrl(encodedData);
          // console.log("decodedDataId",decodedDataId);
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          // console.log("decodedData",decodedData);
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({encodedData,decodedDataId, decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }


  adjustHeights = () => {
    // Adjust department height
    if (this.departmentSelectRef.current && this.departmentDivRef.current) {
      const deptSelectHeight = this.departmentSelectRef.current.controlRef.getBoundingClientRect().height;
      this.departmentDivRef.current.style.height = `${deptSelectHeight}px`;
    }

    // Adjust location height
    if (this.locationSelectRef.current && this.locationDivRef.current) {
      const locSelectHeight = this.locationSelectRef.current.controlRef.getBoundingClientRect().height;
      this.locationDivRef.current.style.height = `${locSelectHeight}px`;
    }
  };


  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetOffboardEmployees`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          // from_date: this.state.from_date,
          // to_date: this.state.to_date,
          // employee_status: this.state.selectOption || " ",
          designation_id: this.state.designation_id || "",
          location_id: this.state.location_id || "",
          department_id: this.state.department_id || "",
          category_id: this.state.category_id || "",
          activated: "0",
         
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        // let departmentRow= data?.data?.map((val)=>{
        //   return { value }
        // })
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSearch: false,
            });
        } else {
          this.setState({ loadingList: false,loadingSearch: false });
        }
      });
  };
  getDepartmentFilterList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Payrolls/GetDepartments`,
        {
            params: {
                date: currentDateAndTime()
            }
            , headers
        }).then(async (response) => {
            var data = response.data;
            // console.log("getDepartmentFilterList", data);
            if (data?.success === true) {
                let row = data?.departments?.map((val) => {
                    return { value: val?.department_id, label: val?.department_title }
                });
                this.setState({ departmentOptions: row},()=>{ this.GetList() });
            } else {
              this.setState({ departmentOptions: ""});
            }
        });
};
getLocationFilterList = () => {
  const { apiURL, apiHeaderJSON } = this.context;
  const headers = apiHeaderJSON;
    axios.get(`${apiURL}Payrolls/GetLocations`,
        {
            params: {
                date: currentDateAndTime()
            }
            , headers
        }).then(async (response) => {
            var data = response.data;
            // console.log("getLocationFilterList", data);
            if (data?.success === true) {
                let row = data?.locations?.map((val) => {
                    return { value: val?.location_id, label: val?.location_title }
                });
                this.setState({ 
                  locationOptions: row} ,
                  ()=>{ this.GetList() });


            } else {
              this.setState({ locationOptions: ""});
            }
        });
};
GetEmploymentMasterList = () => {
  const { apiURL, apiHeaderJSON } = this.context;
  const headers = apiHeaderJSON;
  axios
    .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
    .then((response) => {
      let data = response.data;
      if (response.data.success === true) {
          data= data?.data;
        this.setState((prevState) => ({
          location_options: data.location_list.map((row) => ({
            value: row.location_id,
            label: row.location_title,
          })),
          department_options: data?.department_list.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          designation_options: data?.designation_list.map((row) => ({
              value: row.designation_id,
              label: row.designation_title,
            })),
          grade_options: data?.grade_list.map((row) => ({
              value: row.grade_id,
              label: row.grade_title,
            })),
          state_options: data?.state_list.map((row) => ({
              value: row.state_id,
              label: row.state_title,
            })),
          category_options: data?.category_list.map((row) => ({
              value: row.company_employee_category_id,
              label: row.company_employee_category,
            })),
          type_options: data?.type_list.map((row) => ({
              value: row.company_employee_type_id,
              label: row.company_employee_type,
            })),
        }));  
      }
    });
};

handleExcelDownload = async () => {
  const { apiURL, apiHeaderJSON } = this.context;
  const headers = apiHeaderJSON;
  if(!this.state.bankDetails
    && !this.state.basicDetails
    && !this.state.documentDetails
    && !this.state.educationDetails
    && !this.state.experienceDetails
    && !this.state.familyDetails
    && !this.state.salaryDetails
    && !this.state.statutoryDetails){
      Swal.fire({
        title: `<strong>Failed</strong>`,
        text: "Please select atleast one sheet",
        icon: 'error',
        showConfirmButton: true,
        allowOutsideClick: false,
      });
      this.setState({ loadingExcel: false });
      return;
    }
  const data = {
      activated: this.state.excelEmployeeStatus==="All"? null:this.state.excelEmployeeStatus,
      basicDetails: this.state.basicDetails || false ,
      educationDetails: this.state.educationDetails || false ,
      salaryDetails: this.state.salaryDetails || false ,
      bankDetails: this.state.bankDetails || false ,
      statutoryDetails: this.state.statutoryDetails || false ,
      experienceDetails: this.state.experienceDetails || false ,
      familyDetails: this.state.familyDetails || false ,
      documentDetails: this.state.documentDetails || false ,
  }
  console.log("ExportEmployeeDataToExcel => formData",data);
  Swal.fire({
      title: 'Please wait...',
      html: 'Your file is being prepared for download.',
      allowOutsideClick: false,
      didOpen: () => {
          Swal.showLoading();
      }
  });

  axios.post(`${apiURL}Employees/ExportEmployeeDataToExcel`, data, {
      headers
  })
      .then(async (response) => {
          const { success, employee_data, message } = response.data;

          if (success === true) {
              // Create a new workbook
              const workbook = XLSX.utils.book_new();

              // Function to create worksheet for a category
              const createWorksheet = (dataArray, sheetName) => {
                  const worksheetArray = [];

                  // If it's a 2D array, map each sub-array
                  if (Array.isArray(dataArray[0])) {
                      dataArray.forEach(subArray => {
                          worksheetArray.push(subArray);
                      });
                  } else {
                      // Otherwise, just use the single array
                      worksheetArray.push(dataArray);
                  }

                  const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
                  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
              };

              // Basic Details Sheet
              if (employee_data.BasicDetails) {
                  createWorksheet(employee_data.BasicDetails, 'BasicDetails');
              }
              // Education Details Sheet
              if (employee_data.EducationDetails) {
                  createWorksheet(employee_data.EducationDetails, 'EducationDetails');
              }
              // Salary Details Sheet
              if (employee_data.SalaryDetails) {
                  createWorksheet(employee_data.SalaryDetails, 'SalaryDetails');
              }
              // Statutory Details Sheet (handling 2D array case)
              if (employee_data.StatutoryDetails) {
                  createWorksheet(employee_data.StatutoryDetails, 'StatutoryDetails');
              }
              // Bank Details Sheet 
              if (employee_data.BankDetails) {
                  createWorksheet(employee_data.BankDetails, 'BankDetails');
              }
              // Experience Details Sheet 
              if (employee_data.ExperienceDetails) {
                  createWorksheet(employee_data.ExperienceDetails, 'ExperienceDetails');
              }
              // Family Details Sheet 
              if (employee_data.FamilyDetails) {
                  createWorksheet(employee_data.FamilyDetails, 'FamilyDetails');
              }
              // Document Details Sheet 
              if (employee_data.documentDetails) {
                  createWorksheet(employee_data.documentDetails, 'DocumentDetails');
              }

              const file_name = `Employee Master Excel.xlsx`;

              // Write the workbook to an Excel file
              XLSX.writeFile(workbook, file_name);

              Swal.close();
              Swal.fire({
                  title: `<strong>Success</strong>`,
                  text: message,
                  icon: 'success',
                  showConfirmButton: true
              });
              this.setState({
                excelEmployeeStatus: "All",
                openSheetsOptions:false,
                allSheetChecked:false,
                basicDetails: false,
                educationDetails: false,
                salaryDetails: false,
                bankDetails: false,
                statutoryDetails: false,
                experienceDetails: false,
                familyDetails: false,
                documentDetails: false,
              });
          } else {
              Swal.close();
              Swal.fire({
                  title: `<strong>Failed</strong>`,
                  text: message,
                  icon: 'error',
                  showConfirmButton: true
              });
          }
          this.setState({
            loadingExcel:false
          });
      })
      .catch((error) => {
        this.setState({
          loadingExcel:false
        });
          Swal.close();
          Swal.fire({
              title: `<strong>Failed</strong>`,
              text: error.response ? error.response.message : error.message,
              icon: 'error',
              showConfirmButton: true
          });
      });
};

  handleMultiSelect = (fieldName, selectedOptions) => {
    const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
    // console.log(ids.join(','))
    this.setState({[fieldName]: ids.join(',')});
};

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployee`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: false }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  handleInputSearch = (e) => {
    this.setState({ loadingSearch: true },()=>{
    this.GetList();
    // this.GetEmploymentMasterList();
  })
}

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      if (this.state.keyword === "") {
        this.GetList();
        this.GetEmploymentMasterList();
      }
    });
  };

  // handleSelectChange = (selectedOption) => {
  //   this.setState({ selectOption: selectedOption });
  // };
  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleClearAll = () => {
    this.setState({
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      grade_id: "",
      designation_id: "",
      location_id: "",
      department_id: "",
      category_id: "",
      location_shift_id: "",
      // assigned_leave_status: "All",
      excelEmployeeStatus: "All",
    }
      , () => {
        this.GetList();
       
      });
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetEmploymentMasterList();
        }
      );
    }
  };

  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetEmploymentMasterList();
        }
      );
    }
  };

  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetEmploymentMasterList();
      }
    );
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
        this.GetEmploymentMasterList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const excelEmployeeStatusOptions=[
      {value:"All", label: "All"},
      {value: "1", label: "Active"},
      {value: "0", label: "In Active"},
    ]
    const separationType=[
        {value:"1", label:"Resigned"},
        {value:"2", label:"Terminated"},
        {value:"3", label:"Abscond"},
        {value:"4", label:"Retired"},
        {value:"5", label:"Laid Off"},
        {value:"6", label:"End Of Contract"},
        {value:"7", label:"Death"},
    ];
    const employerRemark=[
        {value:"1", label:"Regretted"},
        {value:"2", label:"Non-Regretted"},
    ]
    const fnfStatus=[
        {value:"0", label:"Pending"},
        {value:"1", label:"Completed"},
        {value:"2", label:"In Progress"},
        {value:"3", label:"On Hold"},
    ]
    const bonusPaid=[
        {value:"1", label:"Paid"},
        {value:"2", label:"Not paid"},
        {value:"3", label:"NA"},
    ]


    return this.state.loadingList? (
      <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
        <div className="text-center">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
      </div>):
      (<div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Employee Offboarding Logs`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-md-3">
                          <label htmlFor="keyword">Search By Employee Name Or Code</label>
                          <div className="input-group">
                            <input
                              type="search"
                              className="form-control"
                              onChange={this.handleInputChange}
                              name="keyword"
                              value={this.state.keyword}
                              aria-label="Recipient's username"
                              aria-describedby="button-addon2"
                              placeholder="Search here"
                            />
                            <button
                              className="btn btn-success"
                              disabled={this.state.loadingSearch}
                              onClick={() => {
                                if (
                                  this.state.keyword &&
                                  !this.state.loadingSearch
                                ) {
                                  this.handleInputSearch();
                                }
                              }}
                              type="button"
                              id="button-addon2"
                            >
                              {this.state.loadingSearch ? (
                                <span
                                  class="spinner-border flex-shrink-0"
                                  role="status"
                                  style={{
                                    width: "0.8rem",
                                    height: "0.8rem",
                                    borderWidth: "2px",
                                  }}
                                >
                                  <span class="visually-hidden">Loading...</span>
                                </span>
                              ) : (
                                <i className="ri-search-line"></i>
                              )}
                            </button>
                          </div>
                    </div>
                    <div className="col-md-3 position-relative">
                            <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Designation</label>
                                </div>
                                <Select
                                options={this.state.designation_options}
                                value={
                                    this.state.designation_id
                                    ? this.state.designation_options.find(
                                        (option) =>
                                            option.value === this.state.designation_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "designation_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Designation`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Location</label>
                                </div>
                                <Select
                                options={this.state.location_options}
                                value={
                                    this.state.location_id
                                    ? this.state.location_options.find(
                                        (option) =>
                                            option.value === this.state.location_id
                                        )
                                    : null
                                }
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "location_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Location`}
                                />
                            </div>
                        </div>
                        <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 7, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Department</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "department_id",
                                    selectedOption
                                    )
                                }
                                placeholder={`Select Department`}
                                options={this.state.department_options}
                                value={
                                    this.state.department_id
                                    ? this.state.department_options.find(
                                        (option) =>
                                            option.value === this.state.department_id
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div>
                        {/* <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Employee Status</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "excelEmployeeStatus",
                                    selectedOption
                                    )
                                }
                                placeholder={`All`}
                                options={excelEmployeeStatusOptions}
                                value={
                                    this.state.excelEmployeeStatus
                                    ? excelEmployeeStatusOptions.find(
                                        (option) =>
                                            option.value === this.state.excelEmployeeStatus
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div> */}
                        {/* <div className="col-md-3 mb-5 position-relative">
                            <div style={{ zIndex: 5, width: "90%" }}className=" position-absolute">
                                <div>
                                <label>Employee Status</label>
                                </div>
                                <Select
                                onChange={(selectedOption) =>
                                    this.handleSelectChange(
                                    "excelEmployeeStatus",
                                    selectedOption
                                    )
                                }
                                placeholder={`All`}
                                options={excelEmployeeStatusOptions}
                                value={
                                    this.state.excelEmployeeStatus
                                    ? excelEmployeeStatus.find(
                                        (option) =>
                                            option.value === this.state.excelEmployeeStatus
                                        )
                                    : null
                                }
                                />
                            </div>
                        </div> */}
                       
                        {/* <div className="col-md-3 ">
                            <div className="row">
                                <div className="col-md-6">
                                <div>
                                    <label>Apply Filter</label>
                                </div>
                                    <SubmitButton
                                    onClick={()=>{
                                        if(!this.state.loadingFilter){
                                            this.setState({loadingFilter: "1"},
                                            () => { this.handleInputSearch()})
                                        }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_leave_status || this.state.assigned_leave_status==="All")}
                                    loading={this.state.loadingFilter==="1"}
                                    loadingMessage='loading' buttonName={"Filter"} icon={'ri-filter-3-fill'} 
                                    type='info' iconSide='left' />
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <label>Clear Filter</label>
                                    </div>
                                    <SubmitButton
                                        onClick={()=>{
                                    if(!this.state.loadingFilter){
                                        this.setState({loadingFilter: "2"},
                                        () => { this.handleClearAll()})
                                    }
                                    }}
                                    disabled={!this.state.grade_id && !this.state.designation_id && !this.state.location_id && !this.state.department_id && !this.state.category_id && (!this.state.assigned_leave_status || this.state.assigned_leave_status==="All")}
                                    loading={this.state.loadingFilter==="2"}
                                    loadingMessage='loading' buttonName={"Clear"} icon={'ri-database-2-line'} 
                                    type='secondary' iconSide='left' />
                                </div>
                            </div>
                        </div> */}
                    {/* <div className='col-md-3'>
                      <label htmlFor="Location" className="form-label" > Select Status </label>
                      <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                      <Select
                        options={excelEmployeeStatusOptions}
                        value={
                            this.state.excelEmployeeStatus
                                ? excelEmployeeStatusOptions.find(option => option.value === this.state.excelEmployeeStatus)
                                : null
                        }
                      onChange={(selectOption) => this.handleSelectChange({ excelEmployeeStatus: selectOption?.value })}
                      placeholder={`Select`}
                      />
                      </div>
                    </div> */}
                    {/* <div style={{ "height": this.state.targetDiv1Height}} className="col-md-3 position-relative me-3">
                        <div className=" position-absolute z-2 w-100 ">
                            <label>Department</label>
                            <Select
                              ref={this.sourceDiv1Ref}
                                onChange={(selectedOptions) => this.handleMultiSelect("department", selectedOptions)}
                                placeholder={"All"}
                                isMulti
                                options={this.state.departmentOptions}
                                value={this.state.department ? this.state.department.split(',').map(id => this.state.departmentOptions.find(option => option.value == id)) : null}
                            />
                        </div>
                      </div>  */}
                      {/* <div id="department" className="col-md-3 position-relative me-3" ref={this.departmentDivRef}>
                        <div className="position-absolute z-2 w-100">
                          <label>Department</label>
                          <Select
                            ref={this.selectRef} // Attach the ref to the Select component
                            onChange={(selectedOptions) => this.handleMultiSelect("department", selectedOptions)}
                            placeholder={"All"}
                            isMulti
                            options={this.state.departmentOptions}
                            value={
                              this.state.department
                                ? this.state.department.split(',').map((id) =>
                                    this.state.departmentOptions.find((option) => option.value == id)
                                  )
                                : null
                            }
                          />
                        </div>
                      </div> */}
                      {/* <div id="location" className="col-md-3 position-relative me-3" ref={this.locationDivRef}>
                        <div className="position-absolute z-2 w-100">
                          <label htmlFor="Location" className="form-label">
                            Location
                          </label>
                          <Select
                            ref={this.locationSelectRef} // Ref for the Select component
                            onChange={(selectedOptions) => this.handleMultiSelect("location", selectedOptions)}
                            placeholder={"All"}
                            isMulti
                            options={this.state.locationOptions}
                            value={
                              this.state.location
                                ? this.state.location.split(",").map((id) =>
                                    this.state.locationOptions.find((option) => option.value == id)
                                  )
                                : null
                            }
                          />
                        </div>
                      </div>  */}
                       {/* <div className='col-md-1 me-3'>
                        <div>
                          <label className="noWrap">Apply Filter</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleInputSearch}
                          disabled={!this.state.department && !this.state.location}
                          className={`btn noWrap btn-info btn-label waves-effect waves-light `}>
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      </div>
                      <div className='col-md-1'>
                        <div>
                          <label className="noWrap">Clear Filter</label>
                        </div>
                        <button
                          type="button"
                          disabled={!this.state.department && !this.state.location}
                          className={`btn noWrap btn-secondary btn-label waves-effect waves-light `}
                          onClick={this.handleClearAll}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>Clear</button>
                      </div>   */}
                  
                    {/* <div className='col-md-3'>
                      <div className='row'>
                        <div className='col-md-6'>
                          <div>
                            <label className="noWrap">Excel Export</label>
                          </div>
                          <SubmitButton onClick={(e)=>{ 
                              if(!this.state.openSheetsOptions){
                                this.setState({ openSheetsOptions: true });
                              }
                              else{
                                if(!this.state.loadingExcel){
                                  this.setState({
                                    loadingExcel: true
                                  }, ()=> this.handleExcelDownload());
                                }
                              }
                              }}
                          loading={this.state.loadingExcel} otherClasses="noWrap" disabled={this.state.loadingExcel} 
                          loadingMessage='Loading' buttonName={this.state.openSheetsOptions? 'Export':'Select Sheets'} icon={'ri-file-excel-2-line'} 
                          type='success' iconSide='left' />
                        </div>
                        {this.state.openSheetsOptions && (
                          <div className='col-md-6'>
                            <div>
                              <label className="noWrap">Cancel Export</label>
                            </div>
                              <SubmitButton onClick={(e)=>{   
                                this.setState({ 
                                  excelEmployeeStatus: "All",
                                  allSheetChecked: false,
                                  openSheetsOptions: false,
                                  basicDetails: false,
                                  educationDetails: false,
                                  salaryDetails: false,
                                  bankDetails: false,
                                  statutoryDetails: false,
                                  experienceDetails: false,
                                  familyDetails: false,
                                  documentDetails: false,
                                });
                                }}
                              loading={this.state.loadingExcel}  disabled={this.state.loadingExcel} 
                              loadingMessage='Loading' buttonName={'Cancel'} icon={'ri-file-excel-2-line'} 
                              type='secondary' iconSide='left' />
                          </div>
                        )}
                      </div>
                    </div> */}
                       {/* <div className='col-md-3'>
                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                      </div>
                      <div className='col-md-3'>
                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                      </div> */}
                      <div className='col-md-1 me-3'>
                        <div>
                          <label className="noWrap">Apply Filter</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleInputSearch}
                          // disabled={!this.state.keyword && !this.state.employee_status  && !this.state.department_title && !this.state.location_title}
                          className={`btn noWrap btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.employee_status  && !this.state.department_id && !this.state.location_id)}`}>
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      </div>
                      <div className='col-md-1'>
                        <div>
                          <label className="noWrap">Clear Filter</label>
                        </div>
                        <button
                          type="button"
                          // disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                          className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.employee_status  && !this.state.department_title && !this.state.location_title)}`}
                          onClick={this.handleClearAll}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>Clear</button>
                      </div> 
                      
                       {/* <div style={{ "height": this.state.targetDiv1Height}} className="col-md-3 position-relative me-3">
                        <div className=" position-absolute z-2 w-100 ">
                            <label>Department</label>
                            <Select
                              ref={this.sourceDiv1Ref}
                                onChange={(selectedOptions) => this.handleMultiSelect("department", selectedOptions)}
                                placeholder={"All"}
                                isMulti
                                options={this.state.departmentOptions}
                                value={this.state.department ? this.state.department.split(',').map(id => this.state.departmentOptions.find(option => option.value == id)) : null}
                            />
                        </div>
                      </div> 
                      <div id="department" className="col-md-3 position-relative me-3" ref={this.departmentDivRef}>
                        <div className="position-absolute z-2 w-100">
                          <label>Department</label>
                          <Select
                            ref={this.selectRef} // Attach the ref to the Select component
                            onChange={(selectedOptions) => this.handleMultiSelect("department", selectedOptions)}
                            placeholder={"All"}
                            isMulti
                            options={this.state.departmentOptions}
                            value={
                              this.state.department
                                ? this.state.department.split(',').map((id) =>
                                    this.state.departmentOptions.find((option) => option.value == id)
                                  )
                                : null
                            }
                          />
                        </div>
                      </div>
                      <div id="location" className="col-md-3 position-relative me-3" ref={this.locationDivRef}>
                        <div className="position-absolute z-2 w-100">
                          <label htmlFor="Location" className="form-label">
                            Location
                          </label>
                          <Select
                            ref={this.locationSelectRef} // Ref for the Select component
                            onChange={(selectedOptions) => this.handleMultiSelect("location", selectedOptions)}
                            placeholder={"All"}
                            isMulti
                            options={this.state.locationOptions}
                            value={
                              this.state.location
                                ? this.state.location.split(",").map((id) =>
                                    this.state.locationOptions.find((option) => option.value == id)
                                  )
                                : null
                            }
                          />
                        </div>
                      </div> 
                       <div className='col-md-1 me-3'>
                        <div>
                          <label className="noWrap">Apply Filter</label>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleInputSearch}
                          disabled={!this.state.department && !this.state.location}
                          className={`btn noWrap btn-info btn-label waves-effect waves-light `}>
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      </div>
                      <div className='col-md-1'>
                        <div>
                          <label className="noWrap">Clear Filter</label>
                        </div>
                        <button
                          type="button"
                          disabled={!this.state.department && !this.state.location}
                          className={`btn noWrap btn-secondary btn-label waves-effect waves-light `}
                          onClick={this.handleClearAll}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>Clear</button>
                      </div>   */}
                    </div>
                    {this.state.openSheetsOptions && (
                      <>
                        <div className="row mt-3">
                          <div className='col-md-3'>
                            <label >Selected sheet will be Exported</label>
                            <div className=" d-flex align-items-center gap-3">
                              <div onClick={(e) => {
                                  this.setState({
                                    allSheetChecked: !this.state.allSheetChecked,
                                      basicDetails: !this.state.allSheetChecked,
                                      educationDetails: !this.state.allSheetChecked,
                                      salaryDetails: !this.state.allSheetChecked,
                                      bankDetails: !this.state.allSheetChecked,
                                      statutoryDetails: !this.state.allSheetChecked,
                                      experienceDetails: !this.state.allSheetChecked,
                                      familyDetails: !this.state.allSheetChecked,
                                      documentDetails: !this.state.allSheetChecked,
                                  });
                                  }} style={{ width: "fit-content" }} className="form-check">
                                    <input checked={this.state.allSheetChecked} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                    <label htmlFor="keyword">Select All</label>
                              </div>
                            </div>
                          </div>
                          <div className='col-md-3'>
                            <div className='position-relative'>
                              <label className="form-label mb-0" > Select Status </label>
                              <div className=" position-absolute w-50 z-2">
                                <Select
                                  options={excelEmployeeStatusOptions}
                                  value={
                                      this.state.excelEmployeeStatus
                                          ? excelEmployeeStatusOptions.find(option => option.value === this.state.excelEmployeeStatus)
                                          : null
                                  }
                                  onChange={(selectOption) => this.setState({ excelEmployeeStatus: selectOption?.value })}
                                  placeholder={`Select`}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ basicDetails: !this.state.basicDetails }); }} className="form-check">
                                  <input checked={this.state.basicDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">BasicDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ educationDetails: !this.state.educationDetails }); }} className="form-check">
                                  <input checked={this.state.educationDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">EducationDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ salaryDetails: !this.state.salaryDetails }); }} className="form-check">
                                  <input checked={this.state.salaryDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">SalaryDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ bankDetails: !this.state.bankDetails }); }} className="form-check">
                                  <input checked={this.state.bankDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">BankDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ statutoryDetails: !this.state.statutoryDetails }); }} className="form-check">
                                  <input checked={this.state.statutoryDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">StatutoryDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ experienceDetails: !this.state.experienceDetails }); }} className="form-check">
                                  <input checked={this.state.experienceDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">ExperienceDetails</label>
                              </div>
                          </div>
                          <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ familyDetails: !this.state.familyDetails }); }} className="form-check">
                                  <input checked={this.state.familyDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">FamilyDetails</label>
                              </div>
                          </div>
                           <div className="col-md-3">
                              <div style={{ width: "fit-content" }} onClick={(e) => { this.setState({ documentDetails: !this.state.documentDetails }); }} className="form-check">
                                  <input checked={this.state.documentDetails} className="form-check-input" type="checkbox" name="chk_child" defaultValue="option1" />
                                  <label htmlFor="keyword">DocumentDetails</label>
                              </div>
                          </div> 
                        </div>
                      </>
                    )}
                    
                  </div>
                  <div className=" card-body">
                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                      <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                        <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr>
                              <th className=" noWrap">Emp Code</th>
                              <th>Name</th>
                              <th>Mobile</th>
                              <th>Email</th>
                              {/* <th>Designation</th> */}
                              <th>Department</th>
                              {/* <th>Location</th> */}
                              {/* <th>RM</th> */}
                              {/* <th className=" noWrap">Emp Type</th> */}
                              {/* <th className=" noWrap">Emp Category</th> */}
                              {/* <th>State</th> */}
                              {/* <th>Status</th> */}
                              {/* <th>Address</th> */}
                              { this.state.decodedData?.includes(3) && (
                              <th className="text-center">Action</th>)}
                            </tr>
                          </thead>
                          {this.state.rows.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={14}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) :
                            <tbody>
                              {this.state.rows.map((row) => {
                                return (
                                  <tr key={row.employee_id}>
                                    <td className=" noWrap" >{row.employee_code || "--"}</td>
                                    <td>
                                      {/* <NavLink to={`/Profile/${row.employee_id}`}> */}
                                        {row.actual_employee_name || "--"}
                                      {/* </NavLink> */}
                                    </td>
                                    <td>{row.employee_mobile_number || "--"}</td>
                                    <td>{row.employee_official_email || row.employee_email_address || "--"}</td>
                                    {/* <td>{row.designation_title}</td> */}
                                    <td>{row.department_title || "--"}</td>
                                    {/* <td>{row.location_title}</td> */}
                                    {/* <td>{row.reporting_manager_name}</td> */}
                                    {/* <td>{row.company_employee_type}</td> */}
                                    {/* <td>{row.company_employee_category}</td> */}
                                    {/* <td>{row.state_title}</td> */}
                                    {/* <td>{row.activated && row.activated == '1' ? "Active" : "Inactive"}</td> */}
                                    {/* <td>{row.employee_address}</td> */}
                                    { this.state.decodedData?.includes(3) && (
                                    <td>
                                        <div className="d-flex justify-content-around gap-2">
                                            { this.state.decodedData?.includes(1) && (
                                            <IconButton 
                                                loading={this.state.loadingList }
                                                onClick={() => {
                                            this.setState(
                                            {
                                                viewEmployeeOffboardingLogs: `${row?.guest_employee_id}`,
                                                formData: row,
                                            },()=> console.log(this.state.formData));
                                            }} type='success' icon='ri-file-info-line' tooltipName='View Logs' tooltipPosition='bottom' />
                                            )}
                                        </div>
                                    </td>)}
                                  </tr>
                                );
                              })}
                            </tbody>}
                        </table>
                    </div>
                    <div className="bg-light w-100 py-2 px-2">
                          <div>
                            <div >
                              <div className="d-flex justify-content-between">
                                <button
                                  disabled={
                                    this.state.prev === false &&
                                      this.state.loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => this.handlePrev()}
                                  className={`btn btn-warning btn-label waves-effect waves-light`}
                                >
                                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                  Previous
                                </button>
                                <div
                                  className="col-md-4"
                                  style={{ display: "flex", alignItems: "center" }}
                                >
                                  {
                                    <small>
                                      Total Records: {this.state.total_records} |
                                      Total Pages: {this.state.total_pages} |
                                      Current Page: {this.state.page}
                                    </small>
                                  }
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={(e) => this.handleChange(e)}
                                  >
                                    {Array.from(
                                      { length: this.state.total_pages },
                                      (_, i) => (
                                        <option
                                          selected={this.state.page === i + 1}
                                          key={i}
                                          value={i + 1}
                                        >
                                          Page {i + 1}
                                        </option>
                                      )
                                    )}
                                  </select>
                                </div>
                                <div className="col-md-2">
                                  <select
                                    className="form-select"
                                    onChange={this.handleLimitChange}
                                    value={this.state.limit}
                                  >
                                    <option value={this.state.total_records}>
                                      All
                                    </option>
                                    {limitOptions.map((option) => (
                                      <option key={option} value={option}>
                                        Limit {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <button
                                  disabled={
                                    this.state.next === false &&
                                      this.state.loadingList === false
                                      ? true
                                      : false
                                  }
                                  type="button"
                                  onClick={() => this.handleNext()}
                                  className={`btn btn-primary btn-label waves-effect right waves-light`}
                                >
                                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                  Next
                                </button>
                              </div>
                            </div>
                          </div>
                    </div >
                  </div>
                  {this.state.viewEmployeeOffboardingLogs && (
                    <div className="modal show" 
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    }}  >
                    <div className="modal-dialog modal-xl"
                        style={{ width: "90%" }}>
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="rmModalLabel">Offboarding Logs</h5>
                            <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeOffboardingLogs:false, formData: {} })} aria-label="Close" />
                        </div>
                        <div className="modal-body">
                        <div className="container mt-2">
                                <form className="row">
                                    <div className="col-md-6 mt-3">
                                        <label className="form-label">Employee code</label>
                                            <input
                                                type="text"
                                                className={`form-control`}
                                                id="employee_code"
                                                name="employee_code"
                                                disabled
                                                value={this.state.formData?.employee_code || "--"}
                                                // onChange={(e) => this.handleInputChange(e)}
                                            />
                                            {/* {this.state.errors.expense_id && <div className="text-danger">{this.state.errors.expense_id}</div>} */}
                                    </div>                
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="actual_employee_name" className="form-label">Employee Name</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="actual_employee_name"
                                            name="actual_employee_name"
                                            disabled
                                            value={this.state.formData?.actual_employee_name || "--"}
                                            // onChange={(e) => this.handleInputChange(e)}
                                        />
                                        {/* {this.state.errors.expense_date && <div className="text-danger">{this.state.errors.expense_date}</div>} */}
                                    </div>                                   
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="resignation_date" className="form-label">Resignation Date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="resignation_date"
                                            name="resignation_date"
                                            disabled
                                            value={this.state.formData?.resignation_date ? formatDate(this.state.formData?.resignation_date) : "--"}
                                            // onChange={(e) => this.handleInputChange(e)}
                                        />
                                        {/* {this.state.errors.expense_date && <div className="text-danger">{this.state.errors.expense_date}</div>} */}
                                    </div>                                   
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="last_working_date" className="form-label">Last Working Date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="last_working_date"
                                            name="last_working_date"
                                            disabled
                                            value={this.state.formData?.last_working_date ? formatDate(this.state.formData?.last_working_date) : "--"}
                                            // onChange={(e) => this.handleInputChange(e)}
                                        />
                                        {/* {this.state.errors.expense_date && <div className="text-danger">{this.state.errors.expense_date}</div>} */}
                                    </div>                                                                      
                                    <div className="col-md-6 mt-3">
                                        <label>Separation Type</label>
                                        <Select
                                        placeholder={`--`}
                                        options={separationType}
                                        value={ this.state.formData?.separation_type ? separationType.find(
                                                (option) => option.value == this.state.formData?.separation_type) : null }
                                        isDisabled
                                        />
                                    </div>                                                                   
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="resignation_reason" className="form-label">Resignation Reason</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="resignation_reason"
                                            name="resignation_reason"
                                            disabled
                                            value={this.state.formData?.resignation_reason || "--"}
                                            placeholder="--"
                                        />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label>Employer Remark</label>
                                        <Select
                                        placeholder={`--`}
                                        options={employerRemark}
                                        value={ this.state.formData?.employer_remark ? employerRemark.find(
                                                (option) => option.value == this.state.formData?.employer_remark) : null }
                                        isDisabled
                                        />
                                    </div> 
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="remark" className="form-label">Remark</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="remark"
                                            name="remark"
                                            disabled
                                            value={this.state.formData?.remark || "--"}
                                            placeholder="--"
                                        />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label>FNF Status</label>
                                        <Select
                                        placeholder={`--`}
                                        options={fnfStatus}
                                        value={ this.state.formData?.fnf_status ? fnfStatus.find(
                                                (option) => option.value == this.state.formData?.fnf_status) : null }
                                        isDisabled
                                        />
                                    </div>  
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="fnf_remark" className="form-label">FNF Remark</label>
                                        <textarea 
                                            className={`form-control`}
                                            id="fnf_remark"
                                            name="fnf_remark"
                                            disabled
                                            value={this.state.formData?.fnf_remark || "--"}
                                            placeholder="--"
                                        />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label>Bonus Paid</label>
                                        <Select
                                        placeholder={`--`}
                                        options={bonusPaid}
                                        value={ this.state.formData?.bonus_paid ? bonusPaid.find(
                                                (option) => option.value == this.state.formData?.bonus_paid) : null }
                                        isDisabled
                                        />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="bonus_paid_date" className="form-label">Bonus Paid Date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="bonus_paid_date"
                                            name="bonus_paid_date"
                                            disabled
                                            value={this.state.formData?.bonus_paid_date ? formatDate(this.state.formData?.bonus_paid_date) : "--"}
                                            // onChange={(e) => this.handleInputChange(e)}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="fnf_settlement_date" className="form-label">FNF Settlement Date</label>
                                        <input
                                            type="text"
                                            className={`form-control`}
                                            id="fnf_settlement_date"
                                            name="fnf_settlement_date"
                                            disabled
                                            value={this.state.formData?.fnf_settlement_date ? formatDate(this.state.formData?.fnf_settlement_date) : "--"}
                                            // onChange={(e) => this.handleInputChange(e)}
                                        />
                                    </div>
                                </form>
                                </div>
                            
                        </div>
                        </div>
                    </div>
                    </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OffboardingLogs);
